import BaseApiAction from '@Actions/base-api-action';

export default class SubmitMetrics extends BaseApiAction {
  runAction() {

    // Prevent submission if any of
    const context = this._payload.metrics.serverContext;
    if(context.type === 'dummy'
    || context.play_session_id === 'dummy'
    || context.session_id === 'dummy') {
      console.log("Dummy session detected - skipping submission");
      return;
    }

    super.invokeCloudFunction({
      name: 'metrics-submitMetrics',
      payload: { ...this._payload },
    });
  }

  onSuccess(data) {
    this._state.app.events.showPlaylistResults.emit(data);
    super.onSuccess(data);
  }
}
